import React from 'react';

const SwaggerContext = React.createContext(null);

export default SwaggerContext;